// Newsletter signups (merchant, Oct 28 2026): Shopify sends a subscriber back to the page address WITHOUT its
// ?view=..., so a signup on /collections/all?view=rewards (or the footer on ?view=gifts) landed on all products.
// On submit we remember where the shopper should land (data-wz-return, else the page they were on) and a thank-you
// line (data-wz-msg); when Shopify's "customer_posted=true" page loads somewhere else, we go there instead and show
// the thank-you as a short notice.
(() => {
  if (window.WZ_subReturn) return;
  window.WZ_subReturn = true;
  const KEY = 'wzSubReturn';
  const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const write = (v) => { try { v ? sessionStorage.setItem(KEY, JSON.stringify(v)) : sessionStorage.removeItem(KEY); } catch (e) {} };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.querySelector('input[name="form_type"][value="customer"]') || !form.querySelector('[name="contact[email]"]')) return;
    const opts = form.closest('[data-wz-return], [data-wz-msg]')?.dataset || {};
    write({ to: opts.wzReturn || location.pathname + location.search, msg: opts.wzMsg || '', id: form.id || '', t: Date.now() });
  }, true);

  const saved = read();
  if (!saved) return;
  if (Date.now() - saved.t > 180000) { write(null); return; }
  const clean = (search) => search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, '');
  const posted = /[?&]customer_posted=true/.test(location.search);
  const target = new URL(saved.to, location.origin);
  const atTarget = location.pathname === target.pathname && clean(location.search) === clean(target.search);
  if (!atTarget) {
    if (posted) { write({ ...saved, t: Date.now() }); location.replace(target.href); }
    return;
  }
  write(null);
  const shown = saved.id && document.getElementById(saved.id)?.querySelector('[role="status"]');
  if (!saved.msg || shown) return;
  const show = () => {
    const note = document.createElement('div');
    note.className = 'wz-sub-toast';
    note.setAttribute('role', 'status');
    note.textContent = saved.msg;
    document.body.append(note);
    setTimeout(() => note.classList.add('is-out'), 6000);
    setTimeout(() => note.remove(), 6600);
  };
  if (document.body) show(); else document.addEventListener('DOMContentLoaded', show);
})();
